const dateTimeToDate = (dateTime: string): string => dateTime.substring(0, 10);
const utcDateNow = (): string => dateTimeToDate(new Date().toISOString());

export { dateTimeToDate, utcDateNow };
